// extracted by mini-css-extract-plugin
export default {"aboutHeader":"InstallmentPlanHeader_aboutHeader__-klfR"};